import { Stack, type Theme, Typography } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import { Alert, AlertButton } from '@side/pantry';
import type { ReactNode } from 'react';

export const ContactChangeAlert = ({
  onIgnore,
  onReviewAndUpdate,
  sx,
  title = 'Outdated Data on a Contact',
}: {
  onIgnore: () => void;
  onReviewAndUpdate: () => void;
  sx?: SystemStyleObject<Theme>;
  title?: ReactNode;
}) => {
  return (
    <Alert
      severity="warning"
      sx={{ m: 2, mt: 0, ...sx }}
      action={
        <Stack
          sx={{
            gap: { xs: 1, lg: 2 },
            flexDirection: { xs: 'row', md: 'column', lg: 'row' },
          }}
        >
          <AlertButton
            severity="warning"
            variant="outlined"
            sx={{ flexBasis: 'fit-content' }}
            onClick={onIgnore}
          >
            Ignore
          </AlertButton>
          <AlertButton
            severity="warning"
            variant="contained"
            sx={{ flexBasis: 'fit-content' }}
            onClick={onReviewAndUpdate}
          >
            Review and Update
          </AlertButton>
        </Stack>
      }
    >
      <Typography variant="h5">{title} </Typography>
      <Typography variant="subtitle2">
        You may choose to update this transaction with the latest information
      </Typography>
    </Alert>
  );
};
